import { LocalStorageKeyEnums } from '../interfaces/enums/LocalStorageKey.enums';

export const getLocalStorageAuthToken = (token = LocalStorageKeyEnums.ADMIN_TOKEN) => {
    return window.localStorage.getItem(token);
};
